"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tab = _interopRequireDefault(require("./Tab"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class Tabs extends _react.default.Component {
  constructor(props) {
    super(props);
    this.handleTabClick = this.handleTabClick.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
  }
  handleTabClick(ind) {
    const {
      active
    } = this.props;
    // Only change the active tab if it's not current active
    if (active !== ind) {
      this.props.setActiveTab(ind);
    }
  }
  handleSelectChange(event) {
    const {
      tabList
    } = this.props;
    let newTabIndex = 0;
    for (let i = 0; i < tabList.length; i += 1) {
      if (tabList[i].name.replace(/\s+/g, '-').toLowerCase() === event.target.value) {
        newTabIndex = i;
      }
    }
    this.props.setActiveTab(newTabIndex);
  }
  render() {
    const {
      active,
      tabList
    } = this.props;
    const selectedValue = tabList && tabList.length > active ? tabList[active].name.replace(/\s+/g, '-').toLowerCase() : '';
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "tabs"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "select"
    }, /*#__PURE__*/_react.default.createElement("select", {
      onChange: this.handleSelectChange,
      value: selectedValue
    }, tabList.map((tab, index) => /*#__PURE__*/_react.default.createElement(_Tab.default, {
      isActive: active === index,
      iconActive: tab.iconActive,
      iconInactive: tab.iconInactive,
      icon: tab.icon,
      key: index,
      name: tab.name,
      dropdown: true
    })))), /*#__PURE__*/_react.default.createElement("ul", null, tabList.map((tab, index) => /*#__PURE__*/_react.default.createElement(_Tab.default, {
      isActive: active === index,
      iconActive: tab.iconActive,
      iconInactive: tab.iconInactive,
      icon: tab.icon,
      key: index,
      name: tab.name,
      index: index,
      onClick: this.handleTabClick.bind(index)
    }))));
  }
}
Tabs.propTypes = {
  active: _propTypes.default.oneOfType([_propTypes.default.number.isRequired, _propTypes.default.string.isRequired]).isRequired,
  tabList: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    icon: _propTypes.default.string,
    iconActive: _propTypes.default.node,
    iconInactive: _propTypes.default.node,
    content: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string])
  })).isRequired,
  setActiveTab: _propTypes.default.func
};
var _default = exports.default = Tabs;
//# sourceMappingURL=Tabs.js.map